import { homeMock } from '@/mocks/home';

export default function Footer() {
  const handleNavClick = (href: string) => {
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="w-full bg-mahjong-primary text-white">
      <div className="px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10">
          {/* Left: Brand */}
          <div>
            <h2 className="text-white text-3xl md:text-4xl font-serif font-bold mb-6">
              雀荘 和
            </h2>
            <p className="text-white/70 text-sm font-sans leading-relaxed max-w-xs mb-8">
              {homeMock.footer.description}
            </p>
            <div className="flex items-center gap-3">
              {homeMock.footer.sns.map((sns) => (
                <a
                  key={sns.icon}
                  href={sns.href}
                  target={sns.href.startsWith('http') ? '_blank' : undefined}
                  rel={sns.href.startsWith('http') ? 'noreferrer' : undefined}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-white/30 text-white transition-all hover:bg-white hover:text-mahjong-primary"
                  aria-label={sns.label}
                >
                  <i className={`${sns.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {/* Center: Info */}
          <div className="space-y-6">
            <div>
              <p className="text-white/50 text-xs font-sans uppercase tracking-wider mb-2">
                住所
              </p>
              <p className="text-white/80 text-sm font-sans leading-relaxed">
                {homeMock.access.address}
              </p>
            </div>
            <div>
              <p className="text-white/50 text-xs font-sans uppercase tracking-wider mb-2">
                電話
              </p>
              <p className="text-white/80 text-sm font-sans">
                {homeMock.access.phone}
              </p>
            </div>
          </div>

          {/* Right: Photo */}
          <div className="hidden md:flex justify-end">
            <div className="rounded-xl overflow-hidden" style={{ width: '200px', height: '260px' }}>
              <img
                src={homeMock.about.image}
                alt="雀荘 和"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="px-6 md:px-10 lg:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-xs font-sans">
            {homeMock.footer.copyright}
          </p>
          <div className="flex items-center gap-6">
            {homeMock.footer.links.map((link) => (
              <button
                key={link.label}
                onClick={() => handleNavClick(link.href)}
                className="text-white/50 text-xs font-sans transition-colors hover:text-white"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}